import NewReleaseBanner from './NewReleaseBanner';
export default NewReleaseBanner;
